const api_staff = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl`;
const api_student = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/api.pl`;

export default {
    authorized() {
        const that = this;

        // Return new promise
        return new Promise(function (resolve, reject) {
            let user = that.getUser();
            let api = user && user.department && user.department == "student" ? api_student : api_staff;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // JSON response
                    if (json.result.match(/OK/i)) {
                        // Store user data in session storage
                        if (user.department && user.department == "student") {
                            that.create_session(json.data);
                        } else {
                            that.create_session(json);
                        }

                        // Return success
                        resolve(true);
                    } else {
                        // Destroy session
                        that.destroy_session();
                        reject(false);
                    }
                })
                .catch(function () {
                    // Destroy session
                    that.destroy_session();
                    reject(false);
                })
        })
    },
    create_session(data) {
        let user = data || {};

        // Delete result and message
        delete user.message;
        delete user.result;

        // Create user session storage
        sessionStorage.setItem('user', JSON.stringify(user));
    },
    destroy_session() {
        // Destroy session storage
        sessionStorage.clear();
    },
    getPermissions() {
        let user = JSON.parse(sessionStorage.getItem('user'));
        let permissions = user.permissions || {};

        return permissions
    },
    getUser() {
        // Return user
        return JSON.parse(sessionStorage.getItem('user')) || {};
    },
    setUser() {}
}